module.exports = __webpack_public_path__ + "static/media/password-active.01c6ae89.png";